/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BonusAdminDeductReqVo,
  BonusAvailableBillTypesSaveReqVo,
  BonusBatchGrantCreateReqVo,
  BonusCompensationMenuUpdateReqVo,
  BonusGrantPlanCreateReqVo,
  ResponseBonusAccountPageVo,
  ResponseBonusAccountRespVo,
  ResponseBonusBatchGrantResultVo,
  ResponseBonusGrantBatchPageVo,
  ResponseBonusGrantPlanListVo,
  ResponseBonusHistoryPageVo,
  ResponseBoolean,
  ResponseListBonusUserSearchVo,
} from '../models/index';
import {
    BonusAdminDeductReqVoFromJSON,
    BonusAdminDeductReqVoToJSON,
    BonusAvailableBillTypesSaveReqVoFromJSON,
    BonusAvailableBillTypesSaveReqVoToJSON,
    BonusBatchGrantCreateReqVoFromJSON,
    BonusBatchGrantCreateReqVoToJSON,
    BonusCompensationMenuUpdateReqVoFromJSON,
    BonusCompensationMenuUpdateReqVoToJSON,
    BonusGrantPlanCreateReqVoFromJSON,
    BonusGrantPlanCreateReqVoToJSON,
    ResponseBonusAccountPageVoFromJSON,
    ResponseBonusAccountPageVoToJSON,
    ResponseBonusAccountRespVoFromJSON,
    ResponseBonusAccountRespVoToJSON,
    ResponseBonusBatchGrantResultVoFromJSON,
    ResponseBonusBatchGrantResultVoToJSON,
    ResponseBonusGrantBatchPageVoFromJSON,
    ResponseBonusGrantBatchPageVoToJSON,
    ResponseBonusGrantPlanListVoFromJSON,
    ResponseBonusGrantPlanListVoToJSON,
    ResponseBonusHistoryPageVoFromJSON,
    ResponseBonusHistoryPageVoToJSON,
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseListBonusUserSearchVoFromJSON,
    ResponseListBonusUserSearchVoToJSON,
} from '../models/index';

export interface BonusAdminAccountBillTypesSavePostRequest {
    bonusAvailableBillTypesSaveReqVo?: BonusAvailableBillTypesSaveReqVo;
}

export interface BonusAdminAccountCompensationMenuUpdatePostRequest {
    bonusCompensationMenuUpdateReqVo?: BonusCompensationMenuUpdateReqVo;
}

export interface BonusAdminAccountPageGetRequest {
    currentPage?: number;
    pageSize?: number;
    userName?: string;
    userCode?: string;
    showCompensationMenu?: number;
}

export interface BonusAdminDeductPostRequest {
    bonusAdminDeductReqVo?: BonusAdminDeductReqVo;
}

export interface BonusAdminGrantBatchCreatePostRequest {
    bonusBatchGrantCreateReqVo?: BonusBatchGrantCreateReqVo;
}

export interface BonusAdminGrantBatchPageGetRequest {
    currentPage?: number;
    pageSize?: number;
    userId?: number;
    planId?: number;
    status?: number;
}

export interface BonusAdminGrantPlanCreatePostRequest {
    bonusGrantPlanCreateReqVo?: BonusGrantPlanCreateReqVo;
}

export interface BonusAdminGrantPlanListGetRequest {
    userId: number;
}

export interface BonusAdminGrantPlanStopPlanIdPostRequest {
    planId: number;
}

export interface BonusAdminHistoryPageGetRequest {
    currentPage?: number;
    pageSize?: number;
    startDate?: string;
    endDate?: string;
    type?: number;
    userName?: string;
    userCode?: string;
    orderCode?: string;
}

export interface BonusAdminUserListByGradeGetRequest {
    gradeId: number;
}

export interface BonusAdminUserSearchGetRequest {
    keyword: string;
}

/**
 * 
 */
export class BonusControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 用户端：查询当前登录用户赠送金账户（余额+可用额度+可用账单类型）
     */
    async bonusAccountGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBonusAccountRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBonusAccountRespVoFromJSON(jsonValue));
    }

    /**
     * 
     * 用户端：查询当前登录用户赠送金账户（余额+可用额度+可用账单类型）
     */
    async bonusAccountGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBonusAccountRespVo> {
        const response = await this.bonusAccountGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端：保存可用账单设置（空集合=全部不可用）
     */
    async bonusAdminAccountBillTypesSavePostRaw(requestParameters: BonusAdminAccountBillTypesSavePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/admin/account/bill-types/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BonusAvailableBillTypesSaveReqVoToJSON(requestParameters['bonusAvailableBillTypesSaveReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端：保存可用账单设置（空集合=全部不可用）
     */
    async bonusAdminAccountBillTypesSavePost(requestParameters: BonusAdminAccountBillTypesSavePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.bonusAdminAccountBillTypesSavePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端：更新赠送金流水画面显示状态（账户列表\"显示与否\"下拉，0隐藏/1显示）
     */
    async bonusAdminAccountCompensationMenuUpdatePostRaw(requestParameters: BonusAdminAccountCompensationMenuUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/admin/account/compensation-menu/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BonusCompensationMenuUpdateReqVoToJSON(requestParameters['bonusCompensationMenuUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端：更新赠送金流水画面显示状态（账户列表\"显示与否\"下拉，0隐藏/1显示）
     */
    async bonusAdminAccountCompensationMenuUpdatePost(requestParameters: BonusAdminAccountCompensationMenuUpdatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.bonusAdminAccountCompensationMenuUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端：赠送金账户分页（余额/冻结/可用额度/待发放/累计已发放/已使用/可用账单类型）
     */
    async bonusAdminAccountPageGetRaw(requestParameters: BonusAdminAccountPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBonusAccountPageVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['showCompensationMenu'] != null) {
            queryParameters['showCompensationMenu'] = requestParameters['showCompensationMenu'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/admin/account/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBonusAccountPageVoFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端：赠送金账户分页（余额/冻结/可用额度/待发放/累计已发放/已使用/可用账单类型）
     */
    async bonusAdminAccountPageGet(requestParameters: BonusAdminAccountPageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBonusAccountPageVo> {
        const response = await this.bonusAdminAccountPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端：管理员扣减赠送金（余额不足报错，不允许扣成负数）
     */
    async bonusAdminDeductPostRaw(requestParameters: BonusAdminDeductPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/admin/deduct`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BonusAdminDeductReqVoToJSON(requestParameters['bonusAdminDeductReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端：管理员扣减赠送金（余额不足报错，不允许扣成负数）
     */
    async bonusAdminDeductPost(requestParameters: BonusAdminDeductPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.bonusAdminDeductPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端：批量创建发放计划（\"批量添加/发放赔偿金\"画面提交，每人一份独立计划，逐人独立处理并返回失败明细）
     */
    async bonusAdminGrantBatchCreatePostRaw(requestParameters: BonusAdminGrantBatchCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBonusBatchGrantResultVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/admin/grant/batch-create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BonusBatchGrantCreateReqVoToJSON(requestParameters['bonusBatchGrantCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBonusBatchGrantResultVoFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端：批量创建发放计划（\"批量添加/发放赔偿金\"画面提交，每人一份独立计划，逐人独立处理并返回失败明细）
     */
    async bonusAdminGrantBatchCreatePost(requestParameters: BonusAdminGrantBatchCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBonusBatchGrantResultVo> {
        const response = await this.bonusAdminGrantBatchCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端：发放批次分页（发放记录表：待发放/已完成/已停止）
     */
    async bonusAdminGrantBatchPageGetRaw(requestParameters: BonusAdminGrantBatchPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBonusGrantBatchPageVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['planId'] != null) {
            queryParameters['planId'] = requestParameters['planId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/admin/grant/batch/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBonusGrantBatchPageVoFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端：发放批次分页（发放记录表：待发放/已完成/已停止）
     */
    async bonusAdminGrantBatchPageGet(requestParameters: BonusAdminGrantBatchPageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBonusGrantBatchPageVo> {
        const response = await this.bonusAdminGrantBatchPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端：创建发放计划（一次性立即执行；分批生成批次由定时任务执行）
     */
    async bonusAdminGrantPlanCreatePostRaw(requestParameters: BonusAdminGrantPlanCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/admin/grant/plan/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BonusGrantPlanCreateReqVoToJSON(requestParameters['bonusGrantPlanCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端：创建发放计划（一次性立即执行；分批生成批次由定时任务执行）
     */
    async bonusAdminGrantPlanCreatePost(requestParameters: BonusAdminGrantPlanCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.bonusAdminGrantPlanCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端：查询用户发放计划列表+发放汇总（已发放/待发放）
     */
    async bonusAdminGrantPlanListGetRaw(requestParameters: BonusAdminGrantPlanListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBonusGrantPlanListVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling bonusAdminGrantPlanListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/admin/grant/plan/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBonusGrantPlanListVoFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端：查询用户发放计划列表+发放汇总（已发放/待发放）
     */
    async bonusAdminGrantPlanListGet(requestParameters: BonusAdminGrantPlanListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBonusGrantPlanListVo> {
        const response = await this.bonusAdminGrantPlanListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端：停止发放计划（计划表行级停止按钮，未执行批次作废）
     */
    async bonusAdminGrantPlanStopPlanIdPostRaw(requestParameters: BonusAdminGrantPlanStopPlanIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling bonusAdminGrantPlanStopPlanIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/admin/grant/plan/stop/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端：停止发放计划（计划表行级停止按钮，未执行批次作废）
     */
    async bonusAdminGrantPlanStopPlanIdPost(requestParameters: BonusAdminGrantPlanStopPlanIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.bonusAdminGrantPlanStopPlanIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端：赠送金流水分页（日期/使用区分/会员/订单编号join搜索）
     */
    async bonusAdminHistoryPageGetRaw(requestParameters: BonusAdminHistoryPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBonusHistoryPageVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/admin/history/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBonusHistoryPageVoFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端：赠送金流水分页（日期/使用区分/会员/订单编号join搜索）
     */
    async bonusAdminHistoryPageGet(requestParameters: BonusAdminHistoryPageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBonusHistoryPageVo> {
        const response = await this.bonusAdminHistoryPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端：查询某等级下全部正常会员（批量发放·会员等级选人，注销/禁用自动排除）
     */
    async bonusAdminUserListByGradeGetRaw(requestParameters: BonusAdminUserListByGradeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListBonusUserSearchVo>> {
        if (requestParameters['gradeId'] == null) {
            throw new runtime.RequiredError(
                'gradeId',
                'Required parameter "gradeId" was null or undefined when calling bonusAdminUserListByGradeGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['gradeId'] != null) {
            queryParameters['gradeId'] = requestParameters['gradeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/admin/user/listByGrade`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListBonusUserSearchVoFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端：查询某等级下全部正常会员（批量发放·会员等级选人，注销/禁用自动排除）
     */
    async bonusAdminUserListByGradeGet(requestParameters: BonusAdminUserListByGradeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListBonusUserSearchVo> {
        const response = await this.bonusAdminUserListByGradeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端：按会员名/编号关键字搜索正常会员（批量发放·个人选人，最多20条）
     */
    async bonusAdminUserSearchGetRaw(requestParameters: BonusAdminUserSearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListBonusUserSearchVo>> {
        if (requestParameters['keyword'] == null) {
            throw new runtime.RequiredError(
                'keyword',
                'Required parameter "keyword" was null or undefined when calling bonusAdminUserSearchGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bonus/admin/user/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListBonusUserSearchVoFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端：按会员名/编号关键字搜索正常会员（批量发放·个人选人，最多20条）
     */
    async bonusAdminUserSearchGet(requestParameters: BonusAdminUserSearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListBonusUserSearchVo> {
        const response = await this.bonusAdminUserSearchGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
